/**
 * Generated by orval 🍺
 * Do not edit manually.
 * FastAPI
 * OpenAPI spec version: 0.1.0
 */
import type { OralExamEgressGuardReconcileParams } from './oralExamEgressGuardReconcileParams';

/**
 * Request model for oral exam egress guard reconciliation job
 */
export interface RunOralExamEgressGuardReconcileJobRequest {
  type: 'oral_exam_egress_guard_reconcile';
  params: OralExamEgressGuardReconcileParams;
  allowOverlappingJobs?: boolean;
}
